import React, { useState, useEffect, useCallback } from "react";
import Header from "../components/Header";
import "../assets/CSS/Dashboard.css";
import axiosInstance from "../axiosConfig";
import Sidebar from "../components/Sidebar";
import DataTable from "react-data-table-component";

function RedProcess() {
  const [data, setData] = useState([]);
  const [isSidebarVisible, setIsSidebarVisible] = useState(true);

  const toggleSidebar = () => {
    setIsSidebarVisible(!isSidebarVisible);
  };

  const user = JSON.parse(localStorage.getItem("userData"));

  // Fetch red process data
  // const fetchRedProcess = useCallback(async () => {
  //   try {
  //     const response = await axiosInstance.get("api/get-RedProcess");
  //     setData(response.data || []);
  //   } catch (error) {
  //     console.error("Error fetching Red Process data:", error);
  //   }
  // }, []);
  const fetchRedProcess = useCallback(async () => {
  try {
    const response = await axiosInstance.get("api/get-RedProcess");
    const allData = response.data || [];

    // Apply filtering for Supervisors
    if (user?.Auth === "Supervisor") {
      const filtered = allData.filter(
        (item) => item.Supervisor === user.Name
      );
      setData(filtered);
    } else {
      setData(allData);
    }
  } catch (error) {
    console.error("Error fetching Red Process data:", error);
  }
}, [user?.Name, user?.Auth]);


  useEffect(() => {
    fetchRedProcess();
  }, [fetchRedProcess]);

  // Columns for DataTable
  const columns = [
    {
      name: "Supervisor",
      selector: (row) => row.Supervisor,
      sortable: true,
    },
    {
      name: "Time", width:"180px",
      selector: (row) => row.UpdateTime,
      sortable: true,
    },
    {
      name: "Department",
      selector: (row) => row.DEPARTMENT,
      sortable: true,
    },
 {
      name: "Quantity",
      selector: (row) => row.Wip_quantity,
      sortable: true,
    },
        {
      name: "Required",
      selector: (row) => row.Required,
      sortable: true,
    },
    {
      name: "Worker In Factory",
      selector: (row) => row.Worker_in_Factory,
      sortable: true,
    },
    {
      name: "Worker To Fill",
      selector: (row) => row.Worker_to_fill,
      sortable: true,
    },
    {
      name: "Result",
      selector: (row) => (
        <span
          style={{
            color:
              row.Result === "Red"
                ? "red"
                : row.Result === "Orange"
                ? "orange"
                : "inherit",
            fontWeight: "bold",
          }}
        >
          {row.Result}
        </span>
      ),
      sortable: true,
    },

  ];

  return (
    <div className="d-flex dashboard">
      <div className={isSidebarVisible ? "sidebar-container" : "sidebar-hidden"}>
        <Sidebar />
      </div>
      <div className="flex-grow-1">
        <Header toggleSidebar={toggleSidebar} isSidebarVisible={isSidebarVisible} />
        <main className="main-container p-4" style={{ height: "-webkit-fill-available" }}>
          <div className="container mt-0">
            <div className="d-flex justify-content-between align-items-center">
              <h3 className="mb-5">Red Process</h3>
            </div>
            <DataTable
              columns={columns}
              data={data}
              pagination
              highlightOnHover
              striped
              persistTableHead
            />
          </div>
        </main>
      </div>
    </div>
  );
}

export default RedProcess;
